import AboutUs from './aboutUs'
import History from './history'
import FullHistory from './fullHistory'
import ContactUs from './contactUs'
import OurTeam from './ourTeam'

export default AboutUs;
export {OurTeam, History, ContactUs, FullHistory}
